import { CatalogPageQuerykeys } from '@enums/react-query-keys';
import { CatalogGuidedSearchResponse } from '@interfaces/api/responses/catalog-page-guided-search-response';

import { useQuery } from '@tanstack/react-query';

type UseGuidedSearchQueryType = {
  guidedSearch: CatalogGuidedSearchResponse;
  showCarousel: boolean;
};

const useGuidedSearchQuery = (): UseGuidedSearchQueryType => {
  const { data: guidedSearch } = useQuery<CatalogGuidedSearchResponse>({
    queryKey: [CatalogPageQuerykeys.GET_GUIDED_SEARCH],
    staleTime: Infinity,
  });

  const showCarousel = guidedSearch?.items?.length > 0;

  return {
    guidedSearch,
    showCarousel,
  };
};
export default useGuidedSearchQuery;
